export default {"src":"/_next/static/media/appstore.1283c145.svg","height":48,"width":146,"blurWidth":0,"blurHeight":0};